import Store from "../../../../Store/Store";

class UnitTypeContainer {
  public pickIdFromLabel(label) {
    const unitTypes = Store.getConfigurator().getState().globalTypes?.UnitType;

    for (const key in unitTypes) {
      if (unitTypes[key].label.toLowerCase() === label.toLowerCase()) {
        return unitTypes[key].id
      }
    }
  }

  public pickLabelFromId(id) {
    const unitTypes = Store.getConfigurator().getState().globalTypes?.UnitType;
    for (const key in unitTypes) {
      if (unitTypes[key].id === id) {
        return unitTypes[key].label
      }
    }
  }
}

export default new UnitTypeContainer();
